export enum TransactionCurrency {
  CAD = 'CAD',
  USD = 'USD',
}

export enum BillingCurrency {
  CAD = 'CAD',
  USD = 'USD',
  ALL = 'ALL',
}

export const toBillingCurrency = (
  currency: TransactionCurrency,
): BillingCurrency => {
  switch (currency) {
    case TransactionCurrency.CAD:
      return BillingCurrency.CAD;
    case TransactionCurrency.USD:
      return BillingCurrency.USD;
  }
};

export const TransactionCurrencyValues = Object.values(TransactionCurrency);

export const BillingCurrencyValues = Object.values(BillingCurrency);
